import { useEffect, useState } from 'react';

import { useLayout } from '@vimeo/clip-ui/hooks/use-layout';

import { useSelectedId } from './use-selected-id';

/**
 * Hook to manage interaction tools state and behavior.
 * @returns An object containing whether the live event view is active.
 */
export const useInteractionTools = () => {
  const { activeSideModule, activeMobileDrawer, onClose } = useLayout();
  const { isLiveEvent } = useSelectedId();
  const [isInteractionToosEnabled, setIsInteractionToolsEnabled] = useState(false);

  // Close the Live Tools side module if the user navigates to a video clip
  useEffect(() => {
    const isLiveToolsSideModuleOpen =
      activeSideModule === 'LIVE_TOOLS' || activeMobileDrawer === 'LIVE_TOOLS';
    if (isLiveToolsSideModuleOpen && !isLiveEvent) {
      onClose?.();
    }
  }, [activeMobileDrawer, activeSideModule, isLiveEvent, onClose]);

  return {
    isInteractionToosEnabled,
    isLiveEvent,
    setIsInteractionToolsEnabled,
  };
};
